import { ServiceAbstract } from '../../ServiceAbstract';
import { Amplify } from '@spidertracks/common';
import { FlightlogsForDeviceTrackFromAPI } from '../../types/FlightLogs';

const PAGINATION_LIMIT = 400;

type FlightLogsForDeviceTrackResponse = FlightlogsForDeviceTrackFromAPI[];

export type SerialBootCountCombination = {
  serialNumber: string;
  bootCount: number;
};

const transformFlightLogs = (flightLogs: FlightLogsForDeviceTrackResponse) => {
  return flightLogs.map(flightLog => ({
    ...flightLog,
    serialNumber: flightLog.serialNumber.toUpperCase()
  }));
};

export class FlightLogsService extends ServiceAbstract {
  public async getFlightLogsForDeviceTrack(
    serialBootCountCombinations: SerialBootCountCombination[]
  ): Promise<FlightLogsForDeviceTrackResponse> {
    const batches = [];
    for (let i = 0; i < serialBootCountCombinations.length; i += PAGINATION_LIMIT) {
      batches.push(serialBootCountCombinations.slice(i, i + PAGINATION_LIMIT));
    }

    const accumulatedFlightLogs: FlightLogsForDeviceTrackResponse = [];
    const promises = [];

    for (const batch of batches) {
      promises.push(
        Amplify.API.post('api.spidertracks.io-authenticated', `v3/flightlogs`, {
          body: {
            deviceTracks: batch.map(combination => ({
              serialNumber: combination.serialNumber,
              bootCount: combination.bootCount
            }))
          }
        }) as FlightLogsForDeviceTrackResponse
      );
    }

    const responses = await Promise.allSettled(promises);

    responses.forEach(response => {
      if (response.status === 'fulfilled') {
        accumulatedFlightLogs.push(...transformFlightLogs(response.value));
      }
    });

    return accumulatedFlightLogs;
  }
}
